import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
// 引入组件文件
import './vant'
import '@/styles/index.scss'
import request from '@/utils/request' 


Vue.config.productionTip = false
Vue.prototype.$http = request


new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
